/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StripeAccountsLoginResponse
 */
export interface StripeAccountsLoginResponse {
    /**
     * 
     * @type {string}
     * @memberof StripeAccountsLoginResponse
     */
    loginUrl: string;
}

/**
 * Check if a given object implements the StripeAccountsLoginResponse interface.
 */
export function instanceOfStripeAccountsLoginResponse(value: object): value is StripeAccountsLoginResponse {
    if (!('loginUrl' in value) || value['loginUrl'] === undefined) return false;
    return true;
}

export function StripeAccountsLoginResponseFromJSON(json: any): StripeAccountsLoginResponse {
    return StripeAccountsLoginResponseFromJSONTyped(json, false);
}

export function StripeAccountsLoginResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripeAccountsLoginResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'loginUrl': json['loginUrl'],
    };
}

export function StripeAccountsLoginResponseToJSON(json: any): StripeAccountsLoginResponse {
    return StripeAccountsLoginResponseToJSONTyped(json, false);
}

export function StripeAccountsLoginResponseToJSONTyped(value?: StripeAccountsLoginResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'loginUrl': value['loginUrl'],
    };
}

